"use client"

import type React from "react"

import { useParams } from "next/navigation"

import { Link } from "@/i18n/navigation"
import { DEFAULT_REGION } from "@/lib/region"
import { localizeHref } from "@/lib/routes"

/**
 * Use this component to create a Next.js `<Link />` that keeps the current region in the url,
 * without having to explicitly pass it as a prop. The default region has no URL segment.
 */
export const LocalizedClientLink = ({
  children,
  href,
  ...props
}: {
  children?: React.ReactNode
  href: string
  className?: string
  onClick?: React.MouseEventHandler<HTMLAnchorElement>
  passHref?: true
} & Omit<React.ComponentProps<typeof Link>, "href" | "children">) => {
  const { countryCode } = useParams<{ countryCode?: string }>()

  return (
    <Link href={localizeHref(href, countryCode ?? DEFAULT_REGION)} {...props}>
      {children}
    </Link>
  )
}
